import { ErrorScreen } from "@internal/ui";
import { Component, type ReactNode, useEffect, useState } from "react";
import { globalError$, reportGlobalError } from "./globalErrors";

class RenderErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    reportGlobalError(error);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

function useGlobalError(): Error | null {
  const [error, setError] = useState<Error | null>(globalError$.value);
  useEffect(() => {
    const subscription = globalError$.subscribe(setError);
    return () => subscription.unsubscribe();
  }, []);
  return error;
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  const error = useGlobalError();
  if (error) return <ErrorScreen error={error} />;
  return <RenderErrorBoundary>{children}</RenderErrorBoundary>;
}
